<script lang="ts">
  import type {
    GroupedTransaction,
    InvoiceRequestDetails,
    ResolvedTransactionDetails,
  } from "../../../api/transactions";
  import { t } from "../../../helpers/translations";
  import { linkTransactionsModal } from "../../../stores/link-transactions-modal-store";
  import IconButton from "../../buttons/IconButton.svelte";
  import ConnectionsSkeleton from "../../skeletons/ConnectionsSkeleton.svelte";
  import ConnectionsEmptyState from "./ConnectionsEmptyState.svelte";
  import RelatedTransactions from "./RelatedTransactions.svelte";
  import SectionHeader from "./SectionHeader.svelte";

  export let isLoading: boolean = false;
  export let emptyStateTitle: string = t("transactionsPanel.connections.emptyTitle");
  export let resolveTooltipTitle: string = t("tooltip.resolveInvoice.title");
  export let canResolveManually: boolean = false;
  export let relatedTransactions: GroupedTransaction[] | undefined;
  export let resolvedTransactionDetails: ResolvedTransactionDetails | undefined;
  export let requestInvoiceDetails: InvoiceRequestDetails | undefined;
  export let onOpenTransaction: (transaction: GroupedTransaction) => void;
  export let onResolveTransaction: (() => void) | undefined = undefined;
  export let onCloseTransaction: () => void;
  export let onAddConnection: () => void;
  export let onCloseConnections: () => void;

  $: linkingModuleVisible = !!$linkTransactionsModal.showLinkingModule;
  $: connectionsAction = linkingModuleVisible ? onCloseConnections : onAddConnection;
</script>

<SectionHeader
  title={t("transactionPanel.connections.title")}
  borderBottom={Boolean(
    relatedTransactions?.length || requestInvoiceDetails || resolvedTransactionDetails?.resolved
  )}
>
  <div class="actions">
    <div class="connections-action" class:close={linkingModuleVisible}>
      <IconButton name="plus" on:click={connectionsAction} highlighted={linkingModuleVisible} />
    </div>

    {#if canResolveManually}
      <IconButton
        name="resolve"
        tooltip={{ title: resolveTooltipTitle, options: { placement: "top" } }}
        on:click={onResolveTransaction}
      />
    {/if}
  </div>
</SectionHeader>

<div class="connections">
  {#if isLoading}
    <ConnectionsSkeleton />
  {:else if relatedTransactions?.length || requestInvoiceDetails || resolvedTransactionDetails?.resolved}
    <RelatedTransactions
      transactions={relatedTransactions}
      {requestInvoiceDetails}
      {resolvedTransactionDetails}
      {onOpenTransaction}
      {onCloseTransaction}
    />
  {:else}
    <ConnectionsEmptyState title={emptyStateTitle} />
  {/if}
</div>

<style>
  .actions {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
  .connections-action {
    transition: all 0.3s ease-in-out;
    margin-left: 16px;
  }

  .connections-action.close {
    color: var(--rekki-dark);
    transform: rotate(45deg) scale(1.1);
  }
</style>
